/**
 * created by wang lei
 编辑器资源库选择弹窗
 *
 */
import React, {Component} from 'react';
import {Input, Modal, Tabs, message, Checkbox, Empty} from "antd";
import {uuid} from "../../../../utils";
import BaseComponent from "../../../../base/BaseComponent";
import {getInfoFromLocalStorage} from "../../../../actions";
import {findObject} from "../../floatTool/securityCheck";
import ComponentsList from "../../../resource/components/ComponentsList";
import {DetailDialog as Picture} from "../../../resource/view/dialog/picture/picture";
import {DetailDialog as Audio} from "../../../resource/view/dialog/audio/audio";
import {Video} from "../../../resource/view/dialog/CurrencyResourceDialog";
import {AUDIO_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../../../constants";
import SelectPublic from "../../../resource/components/Select";

const {TabPane} = Tabs;
const {Search} = Input;

export default class ResourceSelect extends BaseComponent {
    constructor(props) {
        super(props);
        let tabList = this.getAuthTab();
        this.state = {
            visible: false,
            tabList,
            dataSource: [],
            type: "list",
            tabName: tabList && tabList.length > 0 ? tabList[0].key : "",
            queryName: '',
            num: 0,
            checkArray: [],
            newPath: [],
            checkArrayExtendedAttributeJson: true,
            newPicType: ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'JPG', 'JPEG', 'GIF', 'PNG', 'BMP'],
            checkedValue: false,
            selectNum: 0,
            isAll: false,
            disabled: false,
            videoNewPath: [],
        }
    }

    tabsKey = uuid();
    onClose = () => {
        if (typeof this.props.onCloseCall === 'function') {
            this.props.onCloseCall()
        }
        this.setState({visible: false})
    }

    onOk = () => {
        if (!(this.state.checkArray && this.state.checkArray.length)) {
            this.onClose();
            return false
        }
        this.state.checkArray.forEach(item => {
            // 去重 、 视频或图片类型  、  不带锁
            // if (newFile.indexOf(item.id) == -1 && ((this.state.newPicType.indexOf(item.suffix) > -1 || VIDEO_TYPE.indexOf(item.suffix) > -1)) && !(item.extendedAttributeJson && item.extendedAttributeJson.download)) {
            //     newFile.push(item.id)
            // }
            if (!(this.state.newPicType.indexOf(item.suffix) > -1 || VIDEO_TYPE.indexOf(item.suffix) > -1)) {
                message.error("所选资源中，存在暂不支持插入的文件！")
            }
            if (item.extendedAttributeJson && item.extendedAttributeJson.download) {
                message.destroy()
                message.error('所选资源中，存在需要申请下载的资源，请重新选择！');
                this.state.checkArrayExtendedAttributeJson = false
            }
        })
        let videoAndImg = this.state.checkArray.filter(item => ((this.state.newPicType.indexOf(item.suffix) > -1 || VIDEO_TYPE.indexOf(item.suffix) > -1) && !(item.extendedAttributeJson && item.extendedAttributeJson.download)));
        if (!(videoAndImg && videoAndImg.length)) {
            this.onClose();
            return false
        }
        let newFile = videoAndImg.map(item => item.id);

        this.getPathList(newFile, (newPathList) => {
            let account = videoAndImg.length;
            let num = 0;
            let endFun = () => {
                if(typeof this.props.onOkCall === 'function' && this.state.checkArrayExtendedAttributeJson) {
                    this.props.onOkCall(videoAndImg, newPathList,(isSuccess)=>{
                        if(isSuccess) {
                            this.onClose()
                        }
                    })
                } else if (typeof this.props.onOk === 'function' && this.state.checkArrayExtendedAttributeJson) {
                    this.props.onOk(videoAndImg, newPathList)
                    this.onClose()
                }
            }
            let isEndFun = () => {
                num += 1;
                if (num === account) {
                    endFun()
                }
            }
            videoAndImg.forEach((item, i) => {
                let thisFile = newPathList.find(item2 => item2.virtualFileId === item.id);
                let thisPath = thisFile ? thisFile.path : "";
                let videoNewDuration = thisFile ? thisFile.duration : "";
                if (!thisPath) {
                    isEndFun();
                    return;
                }
                if (VIDEO_TYPE.indexOf(item.suffix) > -1) {
                    this.getVideoPath(thisPath, (videoNewPath, videoNewDuration) => {
                        videoAndImg[i].path = videoNewPath;
                        videoAndImg[i].duration = videoNewDuration;
                        isEndFun();
                    })
                } else {
                    videoAndImg[i].path = thisPath;
                    videoAndImg[i].duration = videoNewDuration;
                    isEndFun();
                }
            })
        });
    }

    showModal = () => {
        this.setState({visible: true}, () => {
            if (this.state.tabList && this.state.tabList.length > 0) {
                setTimeout(() => {
                    if(typeof this[this.state.tabName]?.getRootName === "function") {
                        this[this.state.tabName].getRootName()
                    }
                }, 0)
            }
        })

    }

    searchKey = uuid();
    searchChange = () => {
        if(typeof this[this.state.tabName]?.getList === "function") {
            this[this.state.tabName].getList(this.state.queryName, this.state.checkedValue)
        }
        this.setState({isAll: true})
    };

    getAuthTab = () => {
        let tabListConfig = JSON.parse(this.sysConfigGetValueByKey("currency.resource.dialog.tab", `
        [
            {"attr":"menuCode", "value":"allResource", "name":"全部资源", "loadDataModule":"allResource","key":"all"},
            {"attr":"menuCode", "value":"publishResource", "name":"公共资源", "loadDataModule":"publishResource","key":"publish"},
            {"attr":"menuCode", "value":"unitResources", "name":"单位资源", "loadDataModule":"unitResources","key":"dept"},
            {"attr":"menuCode", "value":"personalResources", "name":"个人资源", "loadDataModule":"personalResources","key":"person"}
        ]`));
        let tabList = [];
        let menu = getInfoFromLocalStorage("menu");
        tabListConfig.map(item => {
            let res = findObject(menu, item.attr, item.value);
            if (res) {
                // item.key = item.value;
                tabList.push(item);
            }
        });
        return tabList;
    };

    tabChange(e) {
        this.state.tabName = e;
        this.setState({}, () => {
            if(typeof this?.[this.state.tabName]?.getRootName === "function") {
                this[this.state.tabName].getRootName()
            }
        })
    }

    render() {
        let padding = 20;
        return (
            <Modal
                title={"资源库选择"}
                visible={this.state.visible}
                maskClosable={false}
                width={1000}
                onCancel={this.onClose}
                onOk={() => {
                    this.onOk()
                }}
                bodyStyle={{padding: 0}}
            >
                {this.state.tabList && this.state.tabList.length > 0 ? <div>
                        {/*选项卡*/}
                        <div className={"resourceSelect"}>
                            <Tabs activeKey={this.state.tabName} key={this.tabsKey} onChange={(activeKey) => this.tabChange(activeKey)}>
                                {this.state.tabList.map(item =>
                                    <TabPane tab={item.name} key={item.key}>
                                        {/*搜索框&共有记录*/}
                                        {this.renderSelect()}
                                        {/*资源库组件*/}
                                        {this.renderResource(item)}
                                    </TabPane>
                                )}
                            </Tabs>
                            <style>{`
                            .resourceSelect {padding: 10px ${padding}px 0 ${padding}px;}
                            .resourceSelect .ant-tabs-tab{padding-left:5px;padding-right:5px}
                        `}</style>
                        </div>
                        <Picture key={this.state.newPath} ref={ref => this.detailDialog = ref} path={this.state.newPath}/>
                        <Audio key={this.state.newPath} ref={ref => this.detailDialogAudio = ref}
                               path={this.state.newPath}/>
                        <Video key={this.state.videoNewPath} ref={ref => this.detailDialogVideo = ref}
                               path={this.state.videoNewPath}/>
                    </div>
                    : <Empty style={{padding: 15}}/>
                }

            </Modal>
        )
    }

    renderSelect=()=>{
        let padding = 20;
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return (
            <div style={{margin: padding}}>
                <Search
                    placeholder="请输入"
                    key={this.searchKey}
                    onSearch={this.searchChange}
                    style={{width: 200}}
                    disabled={this.state.isDisabled}
                    value={this.state.queryName}
                    onChange={e => {
                        // this.state.queryName= e.target.value
                        this.setState({queryName: e.target.value})
                    }}
                />
                <Checkbox style={{marginLeft: 10}} checked={this.state.checkedValue}
                          onChange={(e) => {
                              if (e.target.checked === false) {
                                  setTimeout(() => {
                                      if(typeof this[this.state.tabName]?.clearInterval === "function") {
                                          this[this.state.tabName].clearInterval()
                                      }
                                      this.searchChange()
                                      this.setState({isAll: false})
                                  }, 0)
                              }
                              this.setState({checkedValue: e.target.checked})
                          }}>
                </Checkbox>
                <span style={{paddingLeft: '5px'}}>包含子目录</span>
                <span style={{float: "right", letterSpacing: 0}}>共<span style={{
                    color: newSecondSelectColor,
                    margin: "0 5px"
                }}>{this.state.addNum}</span>条记录
                                                <span style={{marginLeft: 20}}>已选（<span style={{
                                                    color: newSecondSelectColor,
                                                    margin: "0 5px"
                                                }}>{this.state.checkArray && this.state.checkArray.length ? this.state.checkArray.length : "0"}</span>）
                                                </span>
                                            </span>
            </div>
        )
    }

    renderResource=(item)=>{
        return (
            <div style={{height: "500px", margin: "0 20px", overflow: "hidden"}}>
                <ComponentsList
                    className={"componentsList"}
                    isEditor={true}
                    name={item.key}
                    tabName={this.state.tabName}
                    queryName={this.state.queryName}
                    Subdirectory={this.state.checkedValue}
                    IsRefresh={true}
                    ref={(ComponentsList) => {
                        this[item.key] = ComponentsList
                    }}
                    getNum={(num) => {
                        this.setState({addNum: num})
                    }}
                    getSelectNum={(selectNum) => {
                        this.setState({addNum: selectNum})
                    }}
                    isDisabled={(isDisabled) => {
                        this.setState({isDisabled})
                    }}
                    doubleClickCall={(file) => {
                        this.state.doubleClickFile = file;
                        // if(this.state.newPicType.indexOf(file.suffix) <= -1 && AUDIO_TYPE.indexOf(file.suffix) <= -1 && VIDEO_TYPE.indexOf(file.suffix) <= -1){
                        //     message.destroy()
                        //     message.error('暂无法查看！');
                        // }
                        if (file.extendedAttributeJson && file.extendedAttributeJson.download) {
                            message.destroy()
                            message.error('您没有所选资源的使用权限，请在媒资管理中申请下载！');
                        } else {
                            this.setState({}, () => {
                                if (this.state.newPicType.indexOf(file.suffix) > -1) {
                                    this.getPath((newPath) => {
                                        this.detailDialog.show(newPath);
                                    })
                                } else if (AUDIO_TYPE.indexOf(file.suffix) > -1) {
                                    this.getPath((newPath) => {
                                        this.detailDialogAudio.show(newPath)
                                    })
                                } else if (VIDEO_TYPE.indexOf(file.suffix) > -1) {
                                    this.getPath((newPath) => {
                                        this.getVideoPath(newPath, (videoNewPath) => {
                                            this.detailDialogVideo.show(videoNewPath)
                                        })
                                    })
                                }
                            })
                        }
                    }}
                    isCheckCall={(checkArray) => {
                        //公共资源下fid与currentId不一致
                        // let newArray=[]
                        // if(checkArray&&checkArray.length){
                        //     // 只选中当前菜单目录下勾选的文件，其他目录下的过滤掉
                        //     newArray = checkArray.filter(item=>item.fid===this.state.currentId);
                        // }
                        this.setState({checkArray})
                    }}
                    getPositionCall={(currentId) => {
                        this.setState({currentId})
                        if (currentId != this.state.currentId) {
                            this.state.checkArray = []
                        }
                    }}
                >
                </ComponentsList>
            </div>
        )
    }
    //预览
    getPath = (call) => {
        let {doubleClickFile} = this.state
        this.request({
            url: '/cm-sites-storage-management/zykFile/path/getPathList',
            method: "get",
            body: {
                virtualFileIds: doubleClickFile.id
            },
            contentType: "json",
            callBack: (data) => {
                let newPath = '';
                if (data) {
                    data.forEach(item => {
                        newPath = item.path
                    })
                }
                this.setState({newPath}, () => {
                    call && call(newPath)
                })
            }
        });
    };

    getVideoPath = (newPath, callVideoNewPath) => {
        this.request({
            url: '/storage/getStorageFileByUrl',
            body: {url: newPath},
            contentType: "json",
            callBack: (data) => {
                let videoNewPath = '';
                let videoNewDuration = 0;
                if (data) {
                    videoNewPath = data.mp4Path
                    videoNewDuration = data.duration
                }
                callVideoNewPath && callVideoNewPath(videoNewPath, videoNewDuration)
                this.setState({videoNewPath}, () => {
                })
            }
        });
    };

    //选中
    getPathList = (newFile, call) => {
        if (newFile && newFile.length > 0) {
            this.request({
                url: '/cm-sites-storage-management/zykFile/path/getPathList',
                method: "get",
                body: {
                    virtualFileIds: newFile
                },
                contentType: "json",
                callBack: (data) => {
                    let newPathList = [];
                    if (data) {
                        newPathList = data
                    }
                    call && call(newPathList)
                },
                errorCallBack: (e) => {
                    call && call([])
                }
            });
        }
    }
}
